import styled from 'styled-components';

export const TvlApyLine = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  font-size: 15px;
  gap: 8px;
`;
